// initial state
const state = {
  all: null,
  macroStatus: { status: 'idle' }
}

// getters
const getters = {
  Watchlist: state => state.all,
  WatchlistMacroStatus: state => state.macroStatus

}

// actions
const actions = {
  getWatchlist ({ commit }, trades) {
    commit('setWatchlist', trades.data)
  },
  deleteWatchlist ({ commit }, trades) {
    commit('deleteWatchlist', trades.data)
  },
  updateWatchlist ({ commit }, watches) {
    commit('updateWatchlist', watches.data)
  },
  watchlistMacroStatus ({ commit }, status) {
    commit('setWatchlistMacroStatus', status.data)
  }
}

// mutations
const mutations = {
  setWatchlist (state, products) {
    state.all = products
  },
  deleteWatchlist (state, username) {
    state.all.watchlist = state.all.watchlist.filter(entry => entry.username.toLowerCase() !== username.toLowerCase());
  },
  updateWatchlist (state, watches) {
    if (!state.all || !state.all.watchlist) return;
    
    const newList = [...state.all.watchlist];
    
    watches.forEach(newEntry => {
      const idx = newList.findIndex(entry => 
        entry.username.toLowerCase() === newEntry.username.toLowerCase()
      );

      if (idx !== -1) {
        newList.splice(idx, 1, { ...newList[idx], ...newEntry });
      } else {
        newList.push(newEntry);
      }
    });
    
    // Replace the whole object to trigger all watchers
    state.all = { ...state.all, watchlist: newList };
  },
  setWatchlistMacroStatus (state, status) {
    state.macroStatus = status || { status: 'idle' }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
